import React from 'react';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const isTorinoCenter = (item) => {
  const title = item?.shopping_center?.title?.toLowerCase() || '';
  const name = item?.shopping_center?.name?.toLowerCase() || '';
  const listTitle = item?.shopping_center_title?.toLowerCase() || '';
  return (
    title.includes('torino') ||
    name.includes('torino') ||
    listTitle.includes('torino')
  );
};

const htmlContent = (html) => {
  if (!html) {
    return '—';
  }
  return (
    <div
      style={{ maxWidth: '100%', wordBreak: 'break-word' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

const iconField = (item) => {
  const url =
    item?.icon?.url || (typeof item?.icon === 'string' ? item.icon : null);
  if (!url) {
    return '—';
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      <img
        src={url}
        alt={item.icon_name || 'icon'}
        style={{ maxWidth: 120, maxHeight: 120, objectFit: 'contain' }}
      />
    </a>
  );
};

const buildLanguageFields = (t, item, lang) => {
  const suffix = lang.toLowerCase();
  const title = item[`title_${suffix}`] || (suffix === 'it' ? item.title : '');
  const description =
    item[`description_${suffix}`] || (suffix === 'it' ? item.description : '');

  return [
    { text: `${t('Titolo')} ${lang}`, value: display(title) },
    {
      text: `${t('Descrizione')} ${lang}`,
      value: htmlContent(description),
    },
  ];
};

export const getServiceViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const outletTitle =
    item.shopping_center?.title || item.shopping_center_title;

  const sections = [
    {
      title: t('Informazioni Generali'),
      fields: [
        { text: t('Outlet Village'), value: display(outletTitle) },
        { text: t('Icona'), value: iconField(item) },
        {
          text: t('Reservation required'),
          value: item.reservation_required ? t('Yes') : t('No'),
        },
      ],
    },
    {
      title: `${t('Contenuto')} (IT)`,
      fields: buildLanguageFields(t, item, 'IT'),
    },
    {
      title: `${t('Contenuto')} (EN)`,
      fields: buildLanguageFields(t, item, 'EN'),
    },
  ];

  if (isTorinoCenter(item)) {
    sections.push({
      title: `${t('Contenuto')} (FR)`,
      fields: buildLanguageFields(t, item, 'FR'),
    });
  }

  return sections;
};
